// JEE Syllabus Data Structure
export const syllabusData = {
  physics: {
    name: "Physics",
    color: "bg-blue-500",
    chapters: [
      // Class 11 Physics
      { id: "phy-1", name: "Units and Measurements", unit: "Mechanics" },
      { id: "phy-2", name: "Motion in a Straight Line", unit: "Mechanics" },
      { id: "phy-3", name: "Motion in a Plane", unit: "Mechanics" },
      { id: "phy-4", name: "Laws of Motion", unit: "Mechanics" },
      { id: "phy-5", name: "Work, Energy and Power", unit: "Mechanics" },
      { id: "phy-6", name: "System of Particles and Rotational Motion", unit: "Mechanics" },
      { id: "phy-7", name: "Gravitation", unit: "Mechanics" },
      { id: "phy-8", name: "Mechanical Properties of Solids", unit: "Properties of Matter" },
      { id: "phy-9", name: "Mechanical Properties of Fluids", unit: "Properties of Matter" },
      { id: "phy-10", name: "Thermal Properties of Matter", unit: "Thermodynamics" },
      { id: "phy-11", name: "Thermodynamics", unit: "Thermodynamics" },
      { id: "phy-12", name: "Kinetic Theory", unit: "Thermodynamics" },
      { id: "phy-13", name: "Oscillations", unit: "Waves" },
      { id: "phy-14", name: "Waves", unit: "Waves" },
      
      // Class 12 Physics
      { id: "phy-15", name: "Electric Charges and Fields", unit: "Electrostatics" },
      { id: "phy-16", name: "Electrostatic Potential and Capacitance", unit: "Electrostatics" },
      { id: "phy-17", name: "Current Electricity", unit: "Current Electricity" },
      { id: "phy-18", name: "Moving Charges and Magnetism", unit: "Magnetism" },
      { id: "phy-19", name: "Magnetism and Matter", unit: "Magnetism" },
      { id: "phy-20", name: "Electromagnetic Induction", unit: "Electromagnetic Induction" },
      { id: "phy-21", name: "Alternating Current", unit: "AC & EM Waves" },
      { id: "phy-22", name: "Electromagnetic Waves", unit: "AC & EM Waves" },
      { id: "phy-23", name: "Ray Optics and Optical Instruments", unit: "Optics" },
      { id: "phy-24", name: "Wave Optics", unit: "Optics" },
      { id: "phy-25", name: "Dual Nature of Radiation and Matter", unit: "Modern Physics" },
      { id: "phy-26", name: "Atoms", unit: "Modern Physics" },
      { id: "phy-27", name: "Nuclei", unit: "Modern Physics" },
      { id: "phy-28", name: "Semiconductor Electronics", unit: "Modern Physics" },
      { id: "phy-29", name: "Communication Systems", unit: "Modern Physics" },
    ]
  },
  
  chemistry: {
    name: "Chemistry",
    color: "bg-green-500",
    chapters: [
      // Class 11 Chemistry
      { id: "chem-1", name: "Some Basic Concepts of Chemistry", unit: "Physical Chemistry" },
      { id: "chem-2", name: "Structure of Atom", unit: "Physical Chemistry" },
      { id: "chem-3", name: "Classification of Elements and Periodicity", unit: "Physical Chemistry" },
      { id: "chem-4", name: "Chemical Bonding and Molecular Structure", unit: "Physical Chemistry" },
      { id: "chem-5", name: "States of Matter", unit: "Physical Chemistry" },
      { id: "chem-6", name: "Thermodynamics", unit: "Physical Chemistry" },
      { id: "chem-7", name: "Equilibrium", unit: "Physical Chemistry" },
      { id: "chem-8", name: "Redox Reactions", unit: "Physical Chemistry" },
      { id: "chem-9", name: "Hydrogen", unit: "Inorganic Chemistry" },
      { id: "chem-10", name: "s-Block Elements", unit: "Inorganic Chemistry" },
      { id: "chem-11", name: "p-Block Elements", unit: "Inorganic Chemistry" },
      { id: "chem-12", name: "Organic Chemistry - Basic Principles", unit: "Organic Chemistry" },
      { id: "chem-13", name: "Hydrocarbons", unit: "Organic Chemistry" },
      { id: "chem-14", name: "Environmental Chemistry", unit: "Physical Chemistry" },
      
      // Class 12 Chemistry
      { id: "chem-15", name: "Solid State", unit: "Physical Chemistry" },
      { id: "chem-16", name: "Solutions", unit: "Physical Chemistry" },
      { id: "chem-17", name: "Electrochemistry", unit: "Physical Chemistry" },
      { id: "chem-18", name: "Chemical Kinetics", unit: "Physical Chemistry" },
      { id: "chem-19", name: "Surface Chemistry", unit: "Physical Chemistry" },
      { id: "chem-20", name: "General Principles and Processes of Isolation of Elements", unit: "Inorganic Chemistry" },
      { id: "chem-21", name: "p-Block Elements (Group 15-18)", unit: "Inorganic Chemistry" },
      { id: "chem-22", name: "d and f Block Elements", unit: "Inorganic Chemistry" },
      { id: "chem-23", name: "Coordination Compounds", unit: "Inorganic Chemistry" },
      { id: "chem-24", name: "Haloalkanes and Haloarenes", unit: "Organic Chemistry" },
      { id: "chem-25", name: "Alcohols, Phenols and Ethers", unit: "Organic Chemistry" },
      { id: "chem-26", name: "Aldehydes, Ketones and Carboxylic Acids", unit: "Organic Chemistry" },
      { id: "chem-27", name: "Amines", unit: "Organic Chemistry" },
      { id: "chem-28", name: "Biomolecules", unit: "Organic Chemistry" },
      { id: "chem-29", name: "Polymers", unit: "Organic Chemistry" },
      { id: "chem-30", name: "Chemistry in Everyday Life", unit: "Organic Chemistry" },
    ]
  },
  
  mathematics: {
    name: "Mathematics",
    color: "bg-purple-500",
    chapters: [
      // Class 11 Mathematics
      { id: "math-1", name: "Sets", unit: "Algebra" },
      { id: "math-2", name: "Relations and Functions", unit: "Algebra" },
      { id: "math-3", name: "Trigonometric Functions", unit: "Trigonometry" },
      { id: "math-4", name: "Principle of Mathematical Induction", unit: "Algebra" },
      { id: "math-5", name: "Complex Numbers and Quadratic Equations", unit: "Algebra" },
      { id: "math-6", name: "Linear Inequalities", unit: "Algebra" },
      { id: "math-7", name: "Permutations and Combinations", unit: "Algebra" },
      { id: "math-8", name: "Binomial Theorem", unit: "Algebra" },
      { id: "math-9", name: "Sequences and Series", unit: "Algebra" },
      { id: "math-10", name: "Straight Lines", unit: "Coordinate Geometry" },
      { id: "math-11", name: "Conic Sections", unit: "Coordinate Geometry" },
      { id: "math-12", name: "Introduction to Three Dimensional Geometry", unit: "Coordinate Geometry" },
      { id: "math-13", name: "Limits and Derivatives", unit: "Calculus" },
      { id: "math-14", name: "Mathematical Reasoning", unit: "Algebra" },
      { id: "math-15", name: "Statistics", unit: "Statistics & Probability" },
      { id: "math-16", name: "Probability", unit: "Statistics & Probability" },
      
      // Class 12 Mathematics
      { id: "math-17", name: "Relations and Functions (Advanced)", unit: "Algebra" },
      { id: "math-18", name: "Inverse Trigonometric Functions", unit: "Trigonometry" },
      { id: "math-19", name: "Matrices", unit: "Algebra" },
      { id: "math-20", name: "Determinants", unit: "Algebra" },
      { id: "math-21", name: "Continuity and Differentiability", unit: "Calculus" },
      { id: "math-22", name: "Application of Derivatives", unit: "Calculus" },
      { id: "math-23", name: "Integrals", unit: "Calculus" },
      { id: "math-24", name: "Application of Integrals", unit: "Calculus" },
      { id: "math-25", name: "Differential Equations", unit: "Calculus" },
      { id: "math-26", name: "Vector Algebra", unit: "Vector & 3D Geometry" },
      { id: "math-27", name: "Three Dimensional Geometry", unit: "Vector & 3D Geometry" },
      { id: "math-28", name: "Linear Programming", unit: "Algebra" },
      { id: "math-29", name: "Probability (Advanced)", unit: "Statistics & Probability" },
    ]
  }
};
